import { Print } from "@mui/icons-material"
import { Button } from "@mui/material"
import { PDFDownloadLink, UsePDFInstance } from "@react-pdf/renderer"
import { FC } from "react"
import { PrintToPdfProps } from "../tableProps.interface"
import PrintTemplate from "./pdfTemplate/PrintTemplate"
import { useTranslation } from "react-i18next";

const PrintTableToPdt: FC<PrintToPdfProps> = ({ columns, rows }) => {
  const { t } = useTranslation()

  return (
    <PDFDownloadLink
      document={<PrintTemplate columns={columns} rows={rows} />}
      fileName="Planering.pdf"
      style={{ textDecoration: "none" }}>
      {({ blob, url, loading, error }: UsePDFInstance) =>
        loading ? (
          <Button>{t("planning.loading_print", "Loading print...")}</Button>
        ) : (
          <Button color="primary" startIcon={<Print />}>
            {t("planning.print", "Print")}
          </Button>
        )
      }
    </PDFDownloadLink>
  )
}

export default PrintTableToPdt
